import { FormField, FormFieldList } from 'ngx-smart-form';
import { IFormField } from 'ngx-smart-form/lib/smart-form/interfaces/i-form-field';
import { AddressFormData } from '../../_widgets/address-form/address-form-data';
import { AddressFormComponent } from '../../_widgets/address-form/address-form.component';

export class SfAddressField<T = any> extends FormField<T> {
  fieldsToBeShown: FormFieldList<AddressFormData> | undefined;
  formData: Partial<AddressFormData> | undefined;
  /* set formData(data: Partial<AddressFormData> | undefined) {
     this.fields = this.genFields(data);
   } */

  title: string;
  constructor(field: IFormField<T> & SfAddressFormFieldData) {
    super(field);
    this.fieldsToBeShown = field.fieldsToBeShown;
    this.formData = field.formData;
    this.title = field.title || 'Indirizzo';
  }
  component = AddressFormComponent;
}

export interface SfAddressFormFieldData {
  fieldsToBeShown?: FormFieldList<AddressFormData>;
  formData?: Partial<AddressFormData>;
  /* set formData(data: Partial<AddressFormData> | undefined) {
    this.fields = this.genFields(data);
  } */

  title?: string;
}
